import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Teleport as _Teleport } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "deleteSubscriptionModalInner" }
const _hoisted_3 = {
  role: "dialog",
  "aria-modal": "true",
  class: "closeButtonWrapper"
}
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = { class: "textWrapper" }
const _hoisted_6 = { class: "buttonsWrapper" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "error" }

import {
  onMounted, onUnmounted, ref, watch,
} from 'vue';
import { Button, Spinner } from '@components/Atoms';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmModal',
  props: {
    to: {},
    error: {}
  },
  emits: ["cancel", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isMounted = ref(false);

const isLoading = ref(false);

const dismiss = () => {
  emit('cancel');
};

const handleConfirm = () => {
  emit('confirm');
  isLoading.value = true;
};

const escapeHandler = (e: KeyboardEvent) => {
  if (e.key === 'Escape') {
    dismiss();
  }
};
document.addEventListener('keydown', escapeHandler);

onUnmounted(() => document.removeEventListener('keydown', escapeHandler));
onMounted(() => {
  isMounted.value = true;
});

watch(() => props.error, (value) => {
  if (value) {
    isLoading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  return (isMounted.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(), _createBlock(_Teleport, { to: _ctx.to }, [
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "deleteSubscriptionModalBackground" }, null, -1)),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("button", {
                "aria-label": _ctx.$t('Close modal'),
                class: "closeButton",
                onClick: dismiss
              }, _cache[0] || (_cache[0] = [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 20 20",
                  fill: "none",
                  role: "img",
                  "aria-hidden": "true"
                }, [
                  _createElementVNode("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M9.97056 11.3848\n                   L17.7487 19.163\n                   L19.163 17.7488\n                   L11.3848 9.97058\n                   L19.163 2.19241\n                   L17.7487 0.778193\n                   L9.97056 8.55637\n                   L2.19239 0.778193\n                   L0.778174 2.19241\n                   L8.55635 9.97058\n                   L0.778174 17.7488\n                   L2.19239 19.163\n                   L9.97056 11.3848Z"
                  })
                ], -1)
              ]), 8, _hoisted_4)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(Button), {
                "on-click": handleConfirm,
                label: _ctx.$t('Confirm'),
                primary: true,
                disabled: isLoading.value,
                class: "button"
              }, {
                default: _withCtx(() => [
                  (isLoading.value)
                    ? (_openBlock(), _createBlock(_unref(Spinner), {
                        key: 0,
                        class: "spinner"
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["label", "disabled"]),
              _createVNode(_unref(Button), {
                "on-click": dismiss,
                label: _ctx.$t('Cancel'),
                secondary: true,
                class: "button secondary"
              }, null, 8, ["label"])
            ]),
            (_ctx.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.error), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ], 8, ["to"]))
      ]))
    : _createCommentVNode("", true)
}
}

})